// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0ccacf94","118":"e5433cff","330":"b2e4cc83","540":"b5e11866","581":"52048f6e","711":"b2e4cc83","717":"fcaca0c2","813":"45a0b0bb","949":"b2e4cc83","961":"c5be533d"}[chunkId] + ".chunk.js";
};